import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkCustomerCateringUserToStoreMutationVariables = Types.Exact<{
  user_uuid: Types.Scalars['ID'];
  store_text_id: Types.Scalars['ID'];
}>;


export type LinkCustomerCateringUserToStoreMutation = { __typename?: 'Mutation', linkCustomerCateringUserToStore: boolean };


export const LinkCustomerCateringUserToStoreDocument = gql`
    mutation linkCustomerCateringUserToStore($user_uuid: ID!, $store_text_id: ID!) {
  linkCustomerCateringUserToStore(
    user_uuid: $user_uuid
    store_text_id: $store_text_id
  )
}
    `;
export type LinkCustomerCateringUserToStoreMutationFn = Apollo.MutationFunction<LinkCustomerCateringUserToStoreMutation, LinkCustomerCateringUserToStoreMutationVariables>;

/**
 * __useLinkCustomerCateringUserToStoreMutation__
 *
 * To run a mutation, you first call `useLinkCustomerCateringUserToStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCustomerCateringUserToStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCustomerCateringUserToStoreMutation, { data, loading, error }] = useLinkCustomerCateringUserToStoreMutation({
 *   variables: {
 *      user_uuid: // value for 'user_uuid'
 *      store_text_id: // value for 'store_text_id'
 *   },
 * });
 */
export function useLinkCustomerCateringUserToStoreMutation(baseOptions?: Apollo.MutationHookOptions<LinkCustomerCateringUserToStoreMutation, LinkCustomerCateringUserToStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCustomerCateringUserToStoreMutation, LinkCustomerCateringUserToStoreMutationVariables>(LinkCustomerCateringUserToStoreDocument, options);
      }
export type LinkCustomerCateringUserToStoreMutationHookResult = ReturnType<typeof useLinkCustomerCateringUserToStoreMutation>;
export type LinkCustomerCateringUserToStoreMutationResult = Apollo.MutationResult<LinkCustomerCateringUserToStoreMutation>;
export type LinkCustomerCateringUserToStoreMutationOptions = Apollo.BaseMutationOptions<LinkCustomerCateringUserToStoreMutation, LinkCustomerCateringUserToStoreMutationVariables>;